export default "__VITE_ASSET__7208e3d9__"